export const CHANNEL_NAME = 'capil-rotendao';
export const PROCESS_EVENT = 'process';
export const DISPLAY_EVENT = 'display';
export const REJECT_EVENT = 'reject';
export const FINISH_EVENT = 'finish';